import React, { useState, useEffect, useMemo } from 'react';
import { Form } from '@unform/web';

import { DefaultInput, DefaultSelect, InformationDiv, RadioGroup, Tooltip } from 'ui-kit-takeat';

import { FaInfoCircle } from 'react-icons/fa';
import { FaArrowsRotate } from 'react-icons/fa6';
import { AverageArea, Container, ConvertArea, ConvertCsosnToCst, ConvertInputDiv, ConvertItemArea, ConvertUnityArea, GroupDiv } from './styles';
import { IoWarningOutline } from "react-icons/io5";
import NFeInfo from '~/services/NFeInfo';
import { Button, Input, Modal, NotificationBanner, Select, IconTrash, formatPrice } from 'takeat-design-system-ui-kit';
import { FiTrash } from 'react-icons/fi';
import { uuid } from 'uuidv4';
import { useCallback } from 'react';

export default function NfeManifestItem({
  item,
  inputs = [],
  cashFlows = [],
  cfop_options,
  user,
  verifiedManifestControls,
  isServiceNfe
}) {
  DefaultSelect.defaultProps = {
    ...DefaultSelect.defaultProps,
    labelStyles: {
      fontSize: '14px'
    },
    containerStyles: {
      fontSize: 14
    }
  }

  function removeAcentos(str){
    let txt = str || '';
    txt = txt.toLowerCase();
    txt = txt.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return txt;
  }

  const [itemsCashFlow, setItemsCashFlow] = useState(item.cash_flows);

  const cfop_filter_options = [
    { default: 5403, value: 1403, label: '1403 - Revenda' },
    { default: 5405, value: 1403, label: '1403 - Revenda' },
    {
      default: 6403,
      value: 2403,
      label:
        '2403 - Compra para comercialização em operação com mercadoria sujeita ao regime de substituição tributária',
    },
    { default: 5102, value: 1102, label: '1102 - Revenda' },
    {
      default: 6102,
      value: 2102,
      label: '2102 - Revenda originado de outro estado',
    },
    {
      default: 6108,
      value: 2102,
      label: '2102 - Revenda originado de outro estado',
    },
  ];

  function searchStrings(array, search){
    const splited = search.split(' ');
    let lastFiltered = null;
    let filtered = null;

    if(splited.length > 0){
      filtered = array.filter(arr => removeAcentos(arr.name).includes(removeAcentos(splited[0])));
    }

    if(splited.length > 1){
      filtered = array.filter(arr => removeAcentos(arr.name).includes(removeAcentos(splited[0])));
      lastFiltered = filtered;

      if(filtered.length === 0){
        filtered = lastFiltered;
      }

      if(filtered.length > 1){
        filtered = filtered.filter(arr => removeAcentos(arr.name).includes(removeAcentos(splited[1])));
        if(filtered.length === 0){
          filtered = lastFiltered;
        }
      }
    }

    if(splited.length > 2){
      filtered = array.filter(arr => removeAcentos(arr?.name).includes(removeAcentos(splited[0])));
      lastFiltered = filtered;

      if(filtered.length > 1){
        filtered = filtered.filter(arr => removeAcentos(arr?.name).includes(removeAcentos(splited[1])));

        if(filtered.length === 0){
          filtered = lastFiltered;
        }

        if(filtered.length > 1){
          filtered = filtered.filter(arr => removeAcentos(arr?.name).includes(removeAcentos(splited[2])));

          if(filtered.length === 0){
            filtered = lastFiltered;
          }
        }else if(filtered.length === 0){
          filtered = lastFiltered;
        }
      }else if(filtered.length === 0){
        filtered = lastFiltered;
      }
    }

    if(filtered?.length > 0){
      filtered = [filtered[0]];
    }

    return filtered[0];
  }

  const cst_options = NFeInfo.cst.filter(cs => cs.cst !== '720').map(cst => {
    return { label: cst.label, value: cst.cst }
  });

  const manifestControl = verifiedManifestControls?.ok === false ? 
    verifiedManifestControls.itens.find(it => it.numero === item.numero_item) :
    null;

  const [input, setInput] = useState(inputs.find(
    (inp) => inp.name_sefaz === item.descricao
  )
  || searchStrings(inputs, item.descricao) 
  || inputs[0]);

  const [cfop, setCfop] = useState(
    (input.cfop && input.cfop !== '') ?
    (cfop_options.find(opt => opt.value.toString() === input.cfop) || cfop_options[0]) :
    cfop_options[0]
  );

  const [cashFlow, setCashFlow] = useState(
    (input.cash_flow_category_subcategory_id && input.cash_flow_category_subcategory_id !== null) ?
    (cashFlows.find(opt => opt.value === input.cash_flow_category_subcategory_id) || cashFlows.find(cf => cf.type === 'insumos' && cf.is_deleted === false) || cashFlows[0]) :
    cashFlows.find(cf => cf.type === 'insumos' && cf.is_deleted === false) || cashFlows[0]
  );

  const [inputName, setInputName] = useState(item.input_name);
  const [inputUnidade, setInputUnidade] = useState({ value: 'UN', label: 'UN'});
  const [inputUnitaryPrice, setInputUnitaryPrice] = useState(item.input_unitary_price);
  const [convertTax, setConvertTax] = useState(item.convert_tax);
  const [unidadeTooltip, setUnidadeTooltip] = useState(false);
  const [unitaryPriceTooltip, setUnitaryPriceTooltip] = useState(false);
  const [notaTooltip, setNotaTooltip] = useState(false);
  const [inputTooltip, setInputTooltip] = useState(false);
  const [inputCst, setInputCst] = useState(cst_options.find(opt => opt.value === item.icms_situacao_tributaria) || { label: item.icms_situacao_tributaria, value: item.icms_situacao_tributaria });

  const [isAverage, setIsAverage] = useState(false);

  const [modalDivide, setModalDivide] = useState(false);

  const [unidadeOptions, setUnidadeOptions] = useState([
    { value: 'UN', label: 'UN'},
    { value: 'KG', label: 'KG'},
    { value: 'L', label: 'L'},
    { value: 'M', label: 'M'},
    { value: 'G', label: 'G'},
    { value: 'ML', label: 'ML'},
    { value: 'PCT', label: 'PCT'},
    { value: 'BDJ', label: 'BDJ'},
    { value: 'CX', label: 'CX'},
    { value: 'Xícara', label: 'Xícara'},
  ]);

  useEffect(() => {
    if(input.cfop && input.cfop !== ''){
      const thisCfop = cfop_options.find(opt => opt.value.toString() === input.cfop);
      if(thisCfop){
        setCfop(thisCfop);
        item.cfop = thisCfop.value;
      }
    }

    item.input_id = input.value;
    item.input_name = input.value !== null ? input.name : item.descricao;

    if(input.cst){
      item.cst = input.cst;
      setInputCst(cst_options.find(opt => opt.value === input.cst) || { label: input.cst, value: input.cst });
      // input.cst);
    }

    // item.input_unidade = input.value !== null ? input.unidade : item.unidade_comercial;
    setInputName(item.input_name);

    const foundUnidade = unidadeOptions.find(opt => opt.value === input.unidade?.toUpperCase());
    if(foundUnidade){
      setInputUnidade(foundUnidade);

      //removendo outras unidade que podem ter sido adicionadas no else abaixo
      if(unidadeOptions[0].label !== 'UN'){
        unidadeOptions.shift();
      }

      item.input_unidade = foundUnidade.value;

    } else if (input.value !== null) {
      //caso nao exista a unidade do insumo selecionado nas options, insere nas opcoes
      const newUnidade = { value: input.unidade?.toUpperCase(), label: input.unidade?.toUpperCase() };
      setInputUnidade(newUnidade);
      setUnidadeOptions([newUnidade, ...unidadeOptions]);

      item.input_unidade = newUnidade.value;
    } else if (input.value === null) {
      //removendo outras unidade que podem ter sido adicionadas no else acima
      if(unidadeOptions[0].label !== 'UN'){
        unidadeOptions.shift();
      }

      setInputUnidade(unidadeOptions[0]);
      item.input_unidade = unidadeOptions[0].value;
    }

    // setInputUnidade(item.input_unidade);

    if(!item.input_id){
      setIsAverage(false);
      item.is_average = false;
    }

    if(isAverage){
      const thisPrice = item.input_quantidade !== 0 ? 
        parseFloat(item.valor_bruto) / item.input_quantidade : 
        parseFloat(item.valor_unitario_comercial);
      
      const unitary = 
        ((thisPrice * parseFloat(item.input_quantidade)) + (parseFloat(input.unitary_price) * parseFloat(input.quantidade))) 
        / (parseFloat(item.input_quantidade) + parseFloat(input.quantidade));

      item.input_unitary_price = unitary;

      setInputUnitaryPrice(unitary);
    }else{
      item.input_unitary_price = item.input_quantidade !== 0 ? 
        parseFloat(item.valor_bruto) / item.input_quantidade : 
        parseFloat(item.valor_unitario_comercial);

      setInputUnitaryPrice(item.input_unitary_price);
    }

    if(input.cash_flow_category_subcategory_id){
      const thisCash = cashFlows.find(opt => opt.value === input.cash_flow_category_subcategory_id);
      if(thisCash){
        setCashFlow(thisCash);
        item.cash_flow_id = thisCash.value;
        item.cash_flow_name = thisCash.label;
        item.cash_flow_disabled = true;

        const newId = thisCash.value;
        // Encontrando o índice do item dentro de item.cash_flows com base no uuid
        const index = item.cash_flows.findIndex(cashFlow => !cashFlow.removable);
        if (index !== -1) {
          // Criação de uma cópia do array para não mutar diretamente
          const updatedCashFlow = [...item.cash_flows];
          
          // Atualizando apenas o id do centro de custo com base no novo valor selecionado
          updatedCashFlow[index] = { 
            ...updatedCashFlow[index], 
            id: newId,
            name: thisCash.label
          };

          // Atualizando o estado com o array atualizado
          item.cash_flows = updatedCashFlow;
          setItemsCashFlow(updatedCashFlow);
        }
      }else{
        item.cash_flow_disabled = false;
      }

    }
  }, [input]);

  function recalculateUnitaryPrice(convert_tax){
    const quantidade = convert_tax !== 0 ? parseFloat(item.quantidade_comercial) * (convert_tax || 1) : 0;
    item.input_quantidade = parseFloat(quantidade.toFixed(4));

    if(isAverage){
      const thisPrice = quantidade !== 0 ? 
        parseFloat(item.valor_bruto) / quantidade : 
        parseFloat(item.valor_unitario_comercial);

      // const unitary = (thisPrice + parseFloat(input.unitary_price)) / 2;

      const unitary = 
        ((thisPrice * parseFloat(item.input_quantidade)) + (parseFloat(input.unitary_price) * parseFloat(input.quantidade))) 
        / (parseFloat(item.input_quantidade) + parseFloat(input.quantidade));

      item.input_unitary_price = unitary;
      setInputUnitaryPrice(item.input_unitary_price);
    }else{
      item.input_unitary_price = quantidade !== 0 ? 
        parseFloat(item.valor_bruto) / quantidade : 
        parseFloat(item.valor_unitario_comercial);

      setInputUnitaryPrice(item.input_unitary_price);
    }
  }

  useEffect(() => {
    if(isAverage){
      const thisPrice = item.input_quantidade !== 0 ? 
        parseFloat(item.valor_bruto) / item.input_quantidade : 
        parseFloat(item.valor_unitario_comercial);
            
      // const unitary = (thisPrice + parseFloat(input.unitary_price)) / 2;

      const unitary = 
        ((thisPrice * parseFloat(item.input_quantidade)) + (parseFloat(input.unitary_price) * parseFloat(input.quantidade))) 
        / (parseFloat(item.input_quantidade) + parseFloat(input.quantidade));

      item.input_unitary_price = unitary;
      setInputUnitaryPrice(unitary);
    }else{
      item.input_unitary_price = item.input_quantidade !== 0 ? 
        parseFloat(item.valor_bruto) / item.input_quantidade : 
        parseFloat(item.valor_unitario_comercial);

      setInputUnitaryPrice(item.input_unitary_price);
    }

    setIsAverage(isAverage);
  }, [isAverage]);

  useEffect(() => {
    if(item.convert_tax !== convertTax){
      setConvertTax(item.convert_tax);
      recalculateUnitaryPrice(item.convert_tax);
    }

    if(item.input_id !== input.id){
      setInput(inputs.find(
        (inp) => inp.value === item.input_id
      ));
    }
  }, [item.convert_tax, item.input_id]);

  const formatCurrency = (value) => {
    return Number(value).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  function priceDifferenceCashFlows(cash_flows) {
    const total = parseFloat(item.valor_bruto);
    const sum = cash_flows.reduce((acc, it) => acc + parseFloat(it.value || 0), 0);
    return total - sum;
  };

  let differencePrice = priceDifferenceCashFlows(itemsCashFlow);

  function toggleCashFlowDivide(is_canceled = false){
    if(!modalDivide){
      setModalDivide(itemsCashFlow);
      return;
    }else{
      if(is_canceled){
        item.cash_flows = modalDivide
        setItemsCashFlow(modalDivide);
      }

      setModalDivide(false);
    }
  }

  //tentando parar o travamento ao abrir modal quando renderiza os centros de custos dentro do modal
  const memoizedCashFlows = useMemo(() => {
    return itemsCashFlow?.map(cf =>
      <div key={cf.uuid} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 8, borderTop: '1px solid #EDEDED', marginTop: 15, paddingTop: 5, paddingBottom: !cf.removable ? 10 : 0 }}>
        <Select
          label="Centro de Custo"
          name="centro"
          options={cashFlows}
          defaultValue={cashFlows.find(cashFlow => cashFlow.value === cf.id) || cashFlow}
          isDisabled={!cf.removable && input.cash_flow_category_subcategory_id && !isServiceNfe}
          info={!cf.removable && 'Centro de custo do insumo'}
          error={cf.value === 0 && 'O valor do centro do custo não pode ser R$ 0,00'}
          onChange={(e) => {
            //o removable é o que dita se o botao de excluir vai estar desabilitado
            //o primeiro centro de custo nunca pode ser removivel pq nao pode nao ter nenhum
            //e se o insumo selecionado tiver centro de custo, ele fica desabilitado pra nao poder mudar
            if(!cf.removable){
              setCashFlow(e);
              item.cash_flow_name = e.label;
              item.cash_flow_id = e.value;
              // item.cash_flows = [{id: e.value, value: item.valor_bruto, name: e.label }];
            }
  
            const newId = e.value;
            const index = item.cash_flows.findIndex(cashFlow => cashFlow.uuid === cf.uuid);
            
            if (index !== -1) {
              const updatedCashFlow = [...item.cash_flows];
              
              updatedCashFlow[index] = { 
                ...updatedCashFlow[index], 
                id: newId,
                name: e.label 
              };
              
              item.cash_flows = updatedCashFlow;
              setItemsCashFlow(updatedCashFlow);
            }
          }}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
  
        <Input
          hasPrefix
          isCurrency
          label="Valor"
          minimumFractionDigits={2}
          value={cf.value}
          onChange={(e) => {
            const newValue = e.target.value || 0;
            const index = item.cash_flows.findIndex(cashFlow => cashFlow.uuid === cf.uuid);
            
            if (index !== -1) {
              const updatedCashFlow = [...item.cash_flows];
              
              updatedCashFlow[index] = { 
                ...updatedCashFlow[index], 
                value: newValue
              };
              
              item.cash_flows = updatedCashFlow;
              setItemsCashFlow(updatedCashFlow);
            }
          }}
        />
  
        <Button
          customColor="#C8131B"
          variant="outlined"
          style={{marginTop: 16}}
          type="button"
          disabled={!cf.removable}
          onClick={() => {                  
            const updatedCashFlow = item.cash_flows.filter(cff => cff.uuid !== cf.uuid);
            item.cash_flows = updatedCashFlow;
            setItemsCashFlow(updatedCashFlow);
          }}
        >
          <IconTrash />
        </Button>
      </div>
    );
  }, [itemsCashFlow]);

  return (
    <Container>
      <Form
        initialData={item}
        onSubmit={() => { return; }}
      >
        <div style={{width: '100%', backgroundColor: '#F4F4F4', marginBottom: 15, display: 'flex', flexDirection: 'inline', gap: 10, height: 25}}>
          <h4>Item <strong>#{item.numero_item}</strong> - Código do Produto: <strong>{item.codigo_produto}</strong></h4>
        </div>

        {manifestControl?.ok === false &&
          <NotificationBanner
            style={{
              alignContent: 'center',
              marginBottom: 15
            }}
            variant="error"
            isOpen
          >
            <div>
              <p>{manifestControl.message}</p>
            </div>
          </NotificationBanner>
        }

        <div style={{display: 'flex', gap: '10px'}}>
          {/* <DefaultInput
            name="codigo_produto"
            title="Cód. Forn."
            type="text"
            value={item.codigo_produto}
            disabled
          /> */}

          <DefaultInput
            name="descricao"
            title="Produto"
            type="text"
            defaultValue={item.descricao}
            disabled={true}
          />

          <DefaultInput
            name="valor_bruto"
            title="Valor total"
            type="text"
            value={`R$ ${item.valor_bruto ? parseFloat(item.valor_bruto).toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) : '-'}`}
            disabled
            containerStyles={{gridColumn: '1'}}
          />

          <DefaultInput 
            name="codigo_ncm" 
            title="NCM" 
            type="text" 
            value={item.codigo_ncm}
            disabled
          />

          <DefaultSelect
            label="CFOP"
            name="cfop"
            options={cfop_options}
            value={cfop}
            disabled={user.use_manifest_control}
            onChange={(e) => {
              setCfop(e);
              item.cfop = e.value;
            }}
          />
        </div>
            
        {/* <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px', marginTop: 15}}>
          <DefaultInput
            name="valor_unitario_comercial"
            title="Custo unitário"
            type="text"
            value={`R$ ${item.valor_unitario_comercial ? parseFloat(item.valor_unitario_comercial).toLocaleString('pt-br', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) : '-'}`}
            disabled
            containerStyles={{gridColumn: '3'}}
          />
        </div> */}

        {user.regime_tributario !== '1' && item.icms_situacao_tributaria && item.icms_situacao_tributaria.length === 3 && !isServiceNfe &&
          <ConvertCsosnToCst>
            <DefaultInput
              name="csosn_entry"
              title="CSOSN"
              type="text"
              value={`${item.icms_situacao_tributaria}`}
              disabled
              containerStyles={{gridColumn: '3'}}
            />

            <div style={{ marginBottom: 10, color: '#979797' }}>
              <FaArrowsRotate size={17}/>
            </div>

            <DefaultSelect
              label="CST"
              name="cst_entry"
              options={cst_options}
              onChange={(e) => {
                item.cst = e.value;
                setInputCst(cst_options.find(opt => opt.value === e.value));
              }}
              value={inputCst}
              disabled={user.use_manifest_control}
              containerStyles={{gridColumn: '1 / span 2'}}
            />

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              minWidth: '200px',
            }}>
              <div style={{ fontSize: 20, color: '#FFA814' }}>
                <IoWarningOutline size={20}/>
              </div>
              <div>Atenção, é necessário converter o CSOSN para CST</div>
            </div>
          </ConvertCsosnToCst>
        }

        {user.regime_tributario !== '1' && item.icms_situacao_tributaria && item.icms_situacao_tributaria.length !== 3 && !isServiceNfe &&
          <ConvertCsosnToCst>
            <DefaultInput
              name="csosn_entry"
              title="CST que veio na nota"
              type="text"
              value={`${item.icms_situacao_tributaria}`}
              disabled
              containerStyles={{gridColumn: '3'}}
            />

            <div style={{ marginBottom: 10, color: '#979797' }}>
              <FaArrowsRotate size={17}/>
            </div>

            <DefaultSelect
              label="CST que vai ser realizada a entrada"
              name="cst_entry"
              options={cst_options}
              // defaultValue={cst_options.find(opt => opt.value === item.icms_situacao_tributaria) || { label: item.icms_situacao_tributaria, value: item.icms_situacao_tributaria }}
              onChange={(e) => {
                item.cst = e.value;
                setInputCst(cst_options.find(opt => opt.value === e.value));
              }}
              value={inputCst}
              disabled={user.use_manifest_control}
              containerStyles={{gridColumn: '1 / span 2'}}
            />

            {/* <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              minWidth: '200px',
            }}>
              <div style={{ fontSize: 20, color: '#FFA814' }}>
                <IoWarningOutline size={20}/>
              </div>
              <div>Atenção, é necessário converter o CSOSN para CST</div>
            </div> */}
          </ConvertCsosnToCst>
        }
        
        {item.cash_flows?.map(cf =>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px', marginTop: 15}}>
            <DefaultSelect
              label="Centro de Custo"
              name="centro"
              id={`select_select_${item.numero_item}_${cf.id}`}
              options={cashFlows}
              value={cashFlows.find(cashFlow => cashFlow.value === cf.id) || cashFlow}
              // disabled={input.cash_flow_category_subcategory_id && !isServiceNfe}
              // onChange={(e) => {
              //   setCashFlow(e);
              //   item.cash_flow_name = e.label;
              //   item.cash_flow_id = e.value;
              //   item.cash_flows = [{id: e.value, value: item.valor_bruto, name: e.label }];
              // }}
              disabled={!cf.removable && input.cash_flow_category_subcategory_id && !isServiceNfe}
              onChange={(e) => {
                //o removable é o que dita se o botao de excluir vai estar desabilitado
                //o primeiro centro de custo nunca pode ser removivel pq nao pode nao ter nenhum
                //e se o insumo selecionado tiver centro de custo, ele fica desabilitado pra nao poder mudar
                if(!cf.removable){
                  setCashFlow(e);
                  item.cash_flow_name = e.label;
                  item.cash_flow_id = e.value;
                  // item.cash_flows = [{id: e.value, value: item.valor_bruto, name: e.label }];
                }

                const newId = e.value;
                // Encontrando o índice do item dentro de item.cash_flows com base no uuid
                const index = item.cash_flows.findIndex(cashFlow => cashFlow.uuid === cf.uuid);
                
                if (index !== -1) {
                  // Criação de uma cópia do array para não mutar diretamente
                  const updatedCashFlow = [...item.cash_flows];
                  
                  // Atualizando apenas o id do centro de custo com base no novo valor selecionado
                  updatedCashFlow[index] = { 
                    ...updatedCashFlow[index], 
                    id: newId,
                    name: e.label 
                  };
                  
                  // Atualizando o estado com o array atualizado
                  item.cash_flows = updatedCashFlow;
                  setItemsCashFlow(updatedCashFlow);
                }
              }}
              containerStyles={{gridColumn: '1 / span 2'}}
            />

            <DefaultInput
              name={`valor_centro_custo_${cf.id}`}
              title="Valor do Centro de Custo"
              type="text"
              value={`R$ ${cf.value ? parseFloat(cf.value).toLocaleString('pt-br', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) : '-'}`}
              disabled
              containerStyles={{gridColumn: '3'}}
            />

            {!cf.removable &&
              <Button
                customColor="#C8131B"
                variant="outlined"
                containerStyles={{gridColumn: '4'}}
                style={{marginTop: 16}}
                type="button"
                onClick={() => toggleCashFlowDivide()}
              >
                Divisão de custo
              </Button>
            }
          </div>
        )}
        
        {/* <div style={{
          display: 'grid', 
          gridTemplateColumns: '1fr 1fr 1fr 1fr', 
          gap: '10px', 
          marginTop: 15
        }}>
          
        </div> */}

        <ConvertInputDiv>
          <ConvertArea>
            {/* ITEM NA NOTA */}
            <ConvertItemArea>
              <div style={{position: 'relative'}}>
                <p>
                  ITEM NA NOTA 
                  <FaInfoCircle
                    onMouseEnter={() => setNotaTooltip(true)}
                    onMouseLeave={() => setNotaTooltip(false)}
                    style={{marginLeft: 5}}
                  />
                </p>

                <Tooltip
                  show={notaTooltip}
                  content={
                    <p style={{ textAlign: 'justify', marginBottom: 0, fontWeight: 400 }}>
                      Informações do item vindo da nota de entrada
                    </p>
                    // Como vai ficar o insumo selecionado quando aceitar a nota
                  }
                  containerStyles={{
                    top: '30px',
                    right: 'unset',
                    width: '330px',
                    left: '0px',
                  }}
                />
              </div>

              <div style={{ width: '100%' }}>
                <DefaultInput 
                  name="descricao_item"
                  title="Nome"
                  disabled={true}
                  defaultValue={item.descricao}
                />
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px',
                alignSelf: 'stretch',
                width: '100%'
              }}>
                <DefaultInput 
                  name="quantidade_item"
                  title="Quantidade"
                  value={item.quantidade_comercial?.replace('.',',')}
                  disabled={true}
                />

                <DefaultInput 
                  name="unidade_item"
                  title="Unidade"
                  disabled={true}
                  value={item.unidade_comercial}
                />
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '20px',
                alignSelf: 'stretch',
                width: '100%'
              }}>
                <DefaultInput 
                  name="custo_item"
                  title="Custo unitário"
                  disabled={true}
                  value={`R$ ${item.valor_unitario_comercial ? parseFloat(item.valor_unitario_comercial).toLocaleString('pt-br', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) : '-'}`}
                />
                
                {!(verifiedManifestControls?.ok === false) && !isServiceNfe &&
                  <DefaultInput
                    name="unidade_convert"
                    title="Taxa de conversão de unidade"
                    type="number"
                    value={convertTax}
                    disabled={(input.value === null && !user.allow_inputs) || user.use_manifest_control}
                    onChange={(e) => {
                      setConvertTax(e.target.value);
                      item.convert_tax = e.target.value;

                      recalculateUnitaryPrice(item.convert_tax);

                      return;
                      //mudei o que ta daqui pra baixo para dentro da funçao recalculateUnitaryPrice
                      const quantidade = item.convert_tax !== 0 ? parseFloat(item.quantidade_comercial) * (item.convert_tax || 1) : 0;
                      item.input_quantidade = parseFloat(quantidade.toFixed(4));

                      if(isAverage){
                        const thisPrice = quantidade !== 0 ? 
                          parseFloat(item.valor_bruto) / quantidade : 
                          parseFloat(item.valor_unitario_comercial);

                        // const unitary = (thisPrice + parseFloat(input.unitary_price)) / 2;

                        const unitary = 
                          ((thisPrice * parseFloat(item.input_quantidade)) + (parseFloat(input.unitary_price) * parseFloat(input.quantidade))) 
                          / (parseFloat(item.input_quantidade) + parseFloat(input.quantidade));

                        item.input_unitary_price = unitary;
                        setInputUnitaryPrice(item.input_unitary_price);
                      }else{
                        item.input_unitary_price = quantidade !== 0 ? 
                          parseFloat(item.valor_bruto) / quantidade : 
                          parseFloat(item.valor_unitario_comercial);

                        setInputUnitaryPrice(item.input_unitary_price);
                      }
                    }}
                  />
                }
              </div>
              
              {!isServiceNfe &&
                <ConvertItemArea style={{ gap: 0 }}>
                  <p style={{ marginBottom: 0 }}>Resumo de entrada:</p>
                  <p style={{fontSize: 15, fontWeight: 400, marginTop: 0}}>
                    <b>{item?.input_quantidade?.toString()?.replace('.',',')} {item.input_unidade}</b> do {item.input_id === null && 'novo'} insumo <b>{item.input_name}</b> custando 
                      <b>
                      {` R$ ${inputUnitaryPrice ? parseFloat(inputUnitaryPrice).toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) : item.valor_unitario_comercial}`}
                      </b> cada
                  </p>
                </ConvertItemArea>
              }
            </ConvertItemArea>
            
            {!(verifiedManifestControls?.ok === false) && !isServiceNfe &&
            <>
              {/* Conversao de unidade */}
              {/* <ConvertUnityArea>
                <p>Converter unidade</p>
                <DefaultInput
                  name="unidade_convert"
                  type="number"
                  value={convertTax}
                  disabled={(input.value === null && !user.allow_inputs) || user.use_manifest_control}
                  onChange={(e) => {
                    setConvertTax(e.target.value);
                    item.convert_tax = e.target.value;

                    recalculateUnitaryPrice(item.convert_tax);

                    return;
                    //mudei o que ta daqui pra baixo para dentro da funçao recalculateUnitaryPrice
                    const quantidade = item.convert_tax !== 0 ? parseFloat(item.quantidade_comercial) * (item.convert_tax || 1) : 0;
                    item.input_quantidade = parseFloat(quantidade.toFixed(4));

                    if(isAverage){
                      const thisPrice = quantidade !== 0 ? 
                        parseFloat(item.valor_bruto) / quantidade : 
                        parseFloat(item.valor_unitario_comercial);

                      // const unitary = (thisPrice + parseFloat(input.unitary_price)) / 2;

                      const unitary = 
                        ((thisPrice * parseFloat(item.input_quantidade)) + (parseFloat(input.unitary_price) * parseFloat(input.quantidade))) 
                        / (parseFloat(item.input_quantidade) + parseFloat(input.quantidade));

                      item.input_unitary_price = unitary;
                      setInputUnitaryPrice(item.input_unitary_price);
                    }else{
                      item.input_unitary_price = quantidade !== 0 ? 
                        parseFloat(item.valor_bruto) / quantidade : 
                        parseFloat(item.valor_unitario_comercial);

                      setInputUnitaryPrice(item.input_unitary_price);
                    }
                  }}
                />
              </ConvertUnityArea> */}

              {/* ITEM NO ESTOQUE */}
              <ConvertItemArea>
                <div style={{position: 'relative'}}>
                  <p>
                    ITEM NO ESTOQUE
                    <FaInfoCircle
                      onMouseEnter={() => setInputTooltip(true)}
                      onMouseLeave={() => setInputTooltip(false)}
                      style={{marginLeft: 5}}
                    />
                  </p>

                  <Tooltip
                    show={inputTooltip}
                    content={
                      <p style={{ textAlign: 'justify', marginBottom: 0, fontWeight: 400 }}>
                        {item.input_id ? 
                          'Como vai ficar o insumo selecionado ao aceitar a nota' : 
                          'Como vai ficar o novo insumo criado ao aceitar a nota'
                        }
                      </p>
                    }
                    containerStyles={{
                      top: '30px',
                      right: 'unset',
                      width: '330px',
                      left: '0px',
                    }}
                  />
                </div>

                <div style={{ 
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px',
                  alignSelf: 'stretch',
                  width: '100%'
                }}>
                  <DefaultSelect
                    label="Relacionar Insumo"
                    name="inputs"
                    id={`input_select_${item.numero_item}`}
                    options={inputs}
                    value={input}
                    disabled={user.use_manifest_control}
                    onChange={(e) => {
                      setInput(e);
                    }}
                  />

                  {input.value === null &&
                    <DefaultInput 
                      name="descricao_input"
                      title="Nome"
                      disabled={(input && input.value !== null) || (input.value === null && !user.allow_inputs)}
                      value={inputName}
                      onChange={e => {
                        setInputName(e.target.value);
                        item.input_name = e.target.value;
                      }}
                      placeholder="Nome do novo insumo"
                    />
                  }

                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px',
                  alignSelf: 'stretch',
                  width: '100%'
                }}>
                  <DefaultInput 
                    name="quantidade_input"
                    title="Quantidade"
                    value={convertTax !== 0 ? parseFloat(item.quantidade_comercial) * (convertTax || 1) : ''}
                    type="number"
                    disabled={(input.value === null && !user.allow_inputs) || user.use_manifest_control}
                    onChange={e => {
                      const convert = e.target.value !== '' ? 
                        (e.target.value || 1) / parseFloat(item.quantidade_comercial) 
                        : 0;

                      setConvertTax(convert);

                      const quantidade = convert !== 0 ? parseFloat(item.quantidade_comercial) * (convert || 1) : 0;
                      item.input_quantidade = quantidade;

                      if(isAverage){
                        const thisPrice = quantidade !== 0 ? 
                          parseFloat(item.valor_bruto) / quantidade : 
                          parseFloat(item.valor_unitario_comercial);
                        
                        // const unitary = (thisPrice + parseFloat(input.unitary_price)) / 2;

                        const unitary = 
                          ((thisPrice * parseFloat(item.input_quantidade)) + (parseFloat(input.unitary_price) * parseFloat(input.quantidade))) 
                          / (parseFloat(item.input_quantidade) + parseFloat(input.quantidade));
                  
                        item.input_unitary_price = unitary;

                        setInputUnitaryPrice(item.input_unitary_price);
                      }else{
                        item.input_unitary_price = quantidade !== 0 ? 
                          parseFloat(item.valor_bruto) / quantidade : 
                          parseFloat(item.valor_unitario_comercial);

                        setInputUnitaryPrice(item.input_unitary_price);
                      }
                    }}
                  />

                  <div style={{position: 'relative', width: '100%'}}>
                    {/* <DefaultInput 
                      name="unidade_input"
                      title={
                        <span>
                          Unidade

                          <FaInfoCircle
                            onMouseEnter={() => setUnidadeTooltip(true)}
                            onMouseLeave={() => setUnidadeTooltip(false)}
                            style={{position: 'absolute', top: 0, left: 65}}
                          />
                        </span>
                      }
                      value={inputUnidade}
                      onChange={e => {
                        setInputUnidade(e.target.value);
                        item.input_unidade = e.target.value;
                      }}
                    /> */}

                    <DefaultSelect
                      label={
                        <span>
                          Unidade

                          <FaInfoCircle
                            onMouseEnter={() => setUnidadeTooltip(true)}
                            onMouseLeave={() => setUnidadeTooltip(false)}
                            style={{position: 'absolute', top: 0, left: 65}}
                          />
                        </span>
                      }
                      name="inputs"
                      id={`unidade_select_${item.numero_item}`}
                      options={unidadeOptions}
                      value={inputUnidade}
                      disabled={!user.allow_inputs || (input.value === null && !user.allow_inputs) || user.use_manifest_control}
                      onChange={e => {
                        setInputUnidade(e);
                        item.input_unidade = e.value;
                      }}
                    />

                    <Tooltip
                      show={unidadeTooltip}
                      content={
                        <p style={{ textAlign: 'justify', marginBottom: 0, fontWeight: 400 }}>
                          Essa unidade será atribuida ao insumo
                        </p>
                      }
                      containerStyles={{
                        top: '30px',
                        right: '0px',
                        width: '330px',
                        left: 'unset',
                      }}
                    />
                  </div>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px',
                  alignSelf: 'stretch',
                  width: '100%'
                }}>
                  <div style={{position: 'relative', width: '100%'}}>
                    <DefaultInput 
                      name="custo_input"
                      title={item.input_id ? 
                        <span>
                          Novo custo unitário

                          <FaInfoCircle
                            onMouseEnter={() => setUnitaryPriceTooltip(true)}
                            onMouseLeave={() => setUnitaryPriceTooltip(false)}
                            style={{marginLeft: 5}}
                          />
                        </span> : 
                        "Custo unitário"
                      }
                      disabled={true}
                      value={`R$ ${inputUnitaryPrice ? parseFloat(inputUnitaryPrice).toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) : item.valor_unitario_comercial}`}
                    />

                    <Tooltip
                      show={unitaryPriceTooltip}
                      content={
                        isAverage ? 
                        <>
                          <p style={{marginBottom: 0}}>Na nota</p>
                          <p style={{ textAlign: 'justify', marginBottom: 0, fontWeight: 400 }}>
                            Custo unitário: {`R$ ${item.valor_bruto ? parseFloat(item.valor_bruto).toLocaleString('pt-br', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) : '-'}`} / {item.input_quantidade?.toString()?.replace('.',',')} = {`R$ ${(parseFloat(item.valor_bruto) / item.input_quantidade) ? parseFloat((parseFloat(item.valor_bruto) / item.input_quantidade)).toLocaleString('pt-br', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) : item.valor_unitario_comercial}`}
                          </p>
                          <p style={{marginBottom: 0, fontWeight: 400}}>
                            Quantidade: {item.input_quantidade?.toString()?.replace('.',',')}
                          </p>

                          <p style={{marginTop: 10, marginBottom: 0}}>
                            Insumo
                          </p>
                          <p style={{marginBottom: 0, fontWeight: 400}}>
                            Custo unitário: {`R$ ${input.unitary_price ? parseFloat(input.unitary_price).toLocaleString('pt-br', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }) : '-'}`}
                          </p>
                          <p style={{marginBottom: 0, fontWeight: 400}}>
                            Quantidade: {input.quantidade?.replace('.',',')}
                          </p>

                          <p style={{marginTop: 10, marginBottom: 0}}>
                            Média 
                          </p>
                          <p style={{fontWeight: 400}}> 
                            ({`R$ ${(parseFloat(item.valor_bruto) / item.input_quantidade) ? parseFloat((parseFloat(item.valor_bruto) / item.input_quantidade)).toLocaleString('pt-br', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) : item.valor_unitario_comercial}`} * {item.input_quantidade?.toString()?.replace('.',',')}) + ({`R$ ${input.unitary_price ? parseFloat(input.unitary_price).toLocaleString('pt-br', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) : '-'}`} * {input.quantidade?.replace('.',',')}) / ({item.input_quantidade?.toString()?.replace('.',',')} + {input.quantidade?.replace('.',',')}) = <b>{`R$ ${inputUnitaryPrice ? parseFloat(inputUnitaryPrice).toLocaleString('pt-br', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }) : item.valor_unitario_comercial}`}</b>
                          </p>
                        </> :
                        <p style={{ textAlign: 'justify', marginBottom: 0, fontWeight: 400 }}>
                          {`R$ ${item.valor_bruto ? parseFloat(item.valor_bruto).toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) : '-'}`} / {item.input_quantidade ? parseFloat(item.input_quantidade).toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) : '-'} = <b>{`R$ ${inputUnitaryPrice ? parseFloat(inputUnitaryPrice).toLocaleString('pt-br', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) : item.valor_unitario_comercial}`}</b>
                        </p> 
                      }
                      containerStyles={{
                        top: '30px',
                        right: '0px',
                        width: '330px',
                        left: 'unset',
                      }}
                    />
                  </div>

                  {input.value !== null &&
                    <DefaultInput 
                      name="custo_input"
                      title="Custo unitário atual"
                      disabled={true}
                      value={`R$ ${input.unitary_price ? parseFloat(input.unitary_price).toLocaleString('pt-br', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) : '-'}`}
                    />
                  }
                </div>

                {input.value !== null &&
                  <AverageArea>
                    <p>Valor custo unitário: </p>
                    <GroupDiv>
                      <RadioGroup 
                        options={item.input_id ? 
                          [{ label: "Novo", value: false }, { label: "Média", value: true }] :
                          [{ label: "Novo", value: false }]
                        }
                        selected={isAverage}
                        horizontal={true}
                        onClick={e => {
                          setIsAverage(e);
                          item.is_average = e;
                        }}
                        customColor="#FF2C3A"
                        containerStyles={{width: 19}}
                      />
                    </GroupDiv>
                  </AverageArea>
                }

                {['5403', '5401', '6403', '6401'].includes(item.cfop_origem) &&
                  <InformationDiv
                    text={`Para produtos com CFOP ${item.cfop_origem}, o valor total corresponde à soma dos seguintes itens: Valor Bruto (${formatCurrency(item.impostos_adicionais.valor_bruto)}) + ICMS ST (${formatCurrency(item.impostos_adicionais.icms_valor_st)}) + IPI (${formatCurrency(item.impostos_adicionais.ipi_valor)}) + Outras Despesas (${formatCurrency(item.impostos_adicionais.valor_outras_despesas)}) + Frete (${formatCurrency(item.impostos_adicionais.valor_frete)}) + FCP ST (${formatCurrency(item.impostos_adicionais.fcp_valor_st)}), totalizando ${formatCurrency(item.valor_bruto)}.`}
                    containerStyles={{alignContent: 'center', height: '100px', width: '100%' }}
                    type='warning'
                  />
                }

                {input.value === null && user.allow_inputs && 
                  <InformationDiv
                    text='Será criado um insumo com a conversão acima.'
                    containerStyles={{alignContent: 'center', height: '50px', width: '100%' }}
                  />
                }

                {input.value === null && !user.allow_inputs && 
                  <InformationDiv
                    text='Você não pode criar insumos. Contate o franqueador se necessário.'
                    containerStyles={{alignContent: 'center', height: '50px', width: '100%' }}
                    type="error"
                  />
                }
              </ConvertItemArea>
            </>}
          </ConvertArea>
          
          {/* {!item.input_id &&
            <ConvertArea>
              <ConvertItemArea style={{ gap: 0 }}>
                <p style={{ marginBottom: 0 }}>Resumo de entrada:</p>
                <p style={{fontSize: 15, fontWeight: 400, marginTop: 0}}>
                  <b>{item?.input_quantidade?.toString()?.replace('.',',')} {item.input_unidade}</b> do {item.input_id === null && 'novo'} insumo <b>{item.input_name}</b> custando 
                    <b>
                    {` R$ ${inputUnitaryPrice ? parseFloat(inputUnitaryPrice).toLocaleString('pt-br', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) : item.valor_unitario_comercial}`}
                    </b> cada
                </p>
              </ConvertItemArea>
            </ConvertArea>
          } */}
        </ConvertInputDiv>
      </Form>

      <Modal open={modalDivide} toggle={() => toggleCashFlowDivide(true)} style={{ height: "fit-content", maxHeight: '96dvh', maxWidth: '662px', gap: 0}}>
        <Modal.Header>
          <h1 style={{ fontSize: 18 }}>Divisão de Custo</h1>
          <p>Código do Produto: {item.codigo_produto} - <b>{item.descricao}</b></p>
        </Modal.Header>
        <Modal.Body style={{ padding: '16px', gap: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 10 }}>
            <Input
              disabled
              hasPrefix
              isCurrency
              label="Valor total do item"
              minimumFractionDigits={2}
              value={item.valor_bruto}
            />

            <Button 
              type="button" 
              style={{ marginTop: 5 }}
              onClick={() => {
                const cashFlowDefault = cashFlows.find(cf => cf.type === 'insumos' && cf.is_deleted === false) || cashFlows[0]
                const updatedCashFlow = [...item.cash_flows, { uuid: uuid(), value: priceDifferenceCashFlows(item.cash_flows), id: cashFlowDefault.value, name: cashFlowDefault.label, removable: true }];
                item.cash_flows = updatedCashFlow;
                setItemsCashFlow(updatedCashFlow);
              }}
            >
              + Adicionar custo
            </Button>
          </div>

          {/* {itemsCashFlow?.map(cf =>
            <div key={cf.uuid} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 8, borderTop: '1px solid #EDEDED', marginTop: 15, paddingTop: 5, paddingBottom: !cf.removable ? 10 : 0 }}>
              <Select
                label="Centro de Custo"
                name="centro"
                options={cashFlows}
                defaultValue={cashFlows.find(cashFlow => cashFlow.value === cf.id) || cashFlow}
                isDisabled={!cf.removable && input.cash_flow_category_subcategory_id && !isServiceNfe}
                info={!cf.removable && 'Centro de custo do insumo'}
                error={cf.value === 0 && 'O valor do centro do custo não pode ser R$ 0,00'}
                onChange={(e) => {
                  //o removable é o que dita se o botao de excluir vai estar desabilitado
                  //o primeiro centro de custo nunca pode ser removivel pq nao pode nao ter nenhum
                  //e se o insumo selecionado tiver centro de custo, ele fica desabilitado pra nao poder mudar
                  if(!cf.removable){
                    setCashFlow(e);
                    item.cash_flow_name = e.label;
                    item.cash_flow_id = e.value;
                    // item.cash_flows = [{id: e.value, value: item.valor_bruto, name: e.label }];
                  }

                  const newId = e.value;
                  const index = item.cash_flows.findIndex(cashFlow => cashFlow.uuid === cf.uuid);
                  
                  if (index !== -1) {
                    const updatedCashFlow = [...item.cash_flows];
                    
                    updatedCashFlow[index] = { 
                      ...updatedCashFlow[index], 
                      id: newId,
                      name: e.label 
                    };
                    
                    item.cash_flows = updatedCashFlow;
                    setItemsCashFlow(updatedCashFlow);
                  }
                }}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />

              <Input
                hasPrefix
                isCurrency
                label="Valor"
                minimumFractionDigits={2}
                value={cf.value}
                onChange={(e) => {
                  const newValue = e.target.value || 0;
                  const index = item.cash_flows.findIndex(cashFlow => cashFlow.uuid === cf.uuid);
                  
                  if (index !== -1) {
                    const updatedCashFlow = [...item.cash_flows];
                    
                    updatedCashFlow[index] = { 
                      ...updatedCashFlow[index], 
                      value: newValue
                    };
                    
                    item.cash_flows = updatedCashFlow;
                    setItemsCashFlow(updatedCashFlow);
                  }
                }}
              />

              <Button
                customColor="#C8131B"
                variant="outlined"
                style={{marginTop: 16}}
                type="button"
                disabled={!cf.removable}
                onClick={() => {                  
                  const updatedCashFlow = item.cash_flows.filter(cff => cff.uuid !== cf.uuid);
                  item.cash_flows = updatedCashFlow;
                  setItemsCashFlow(updatedCashFlow);
                }}
              >
                <IconTrash />
              </Button>
            </div>
          )} */}

          {memoizedCashFlows}

          {priceDifferenceCashFlows(itemsCashFlow) !== 0 &&
            <div style={{
              background: '#FAE8E9', borderRadius: 8, width: '100%', display: 'flex',
              padding: '4px 16px',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch', 
              marginTop: 20,
              fontSize: 12,
              color: differencePrice > 0 ? '#545454' : '#A82743'
            }}>
              {differencePrice > 0 ? `Restam ${formatPrice(priceDifferenceCashFlows(itemsCashFlow))} para atingir o valor total` : `A somatória dos valores não deve ultrapassar ${formatPrice(item.valor_bruto)}. Diferença de ${formatPrice(- priceDifferenceCashFlows(itemsCashFlow))}`}
            </div>
          }
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'space-between', paddingTop: 16 }}>
          <Button onClick={() => toggleCashFlowDivide(true)} type="button" variant='outlined'>Cancelar</Button>
          <Button onClick={() => toggleCashFlowDivide(false)} type='button' disabled={priceDifferenceCashFlows(itemsCashFlow) !== 0 || itemsCashFlow.find(it => it.value === 0)}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}